import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "worksheetTypeDefinition", params: {} },
              },
            },
            [_vm._v(" Worksheet Type ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                to: { name: "worksheetTypeDefinitionView", params: {} },
              },
            },
            [_vm._v(" View Worksheet Type ")]
          ),
        ],
        1
      ),
      _vm.loaded
        ? _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v(" View Worksheet Type ")]),
              _c(
                VCardText,
                [
                  _c(VSimpleTable, {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("tbody", [
                                _vm.worksheetTypeDefinition.worksheetType
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Type")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.worksheetTypeDefinition
                                              .worksheetType
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasDocumentNumber
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Document Number")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasDocumentNumber
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasWeightSettings
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Weight Setings: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasWeightSettings
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasLocation
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Location")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasLocation
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasProcessType
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Process Type: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasProcessType
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasProduct
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Product")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasProduct
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasDeductibleWeight
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Deductible Weight: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasDeductibleWeight
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasTargetWeight
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Target Weight: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasTargetWeight
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition
                                  .hasNetAdjustmentWeight
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Net Adjustment Weight: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasNetAdjustmentWeight
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasMemo
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Memo")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasMemo
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasEntryPhoto
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Require Photo: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasEntryPhoto
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasNotes
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Notes: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasNotes
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasEntryNotes
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Has Entry Notes: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasEntryNotes
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasSupplier
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Supplier")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasSupplier
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.hasCustomer
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Customer")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasCustomer
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition
                                  .hasInventorySelection
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Has Inventory Selection")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("yesNo")(
                                              _vm.worksheetTypeDefinition
                                                .hasInventorySelection
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.worksheetTypeDefinition.createDate
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Created On")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              _vm.worksheetTypeDefinition
                                                .createDate
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3855410316
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between ma-5" },
        [
          _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v("Back")]),
          _c(
            VBtn,
            {
              attrs: { color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.edit(_vm.id)
                },
              },
            },
            [_vm._v("Edit")]
          ),
          _c("span"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }